import React from 'react'
import { TESTIMONIALS } from '../data/testimonials'
import { useScrollReveal } from '../hooks/useScrollReveal'
import TestimonialCard from './TestimonialCard'

const ForSinglesSection: React.FC = () => {
  const { ref, visible } = useScrollReveal<HTMLDivElement>()

  return (
    <section id="for-singles" className="v2-section v2-section--dotted">
      <div ref={ref} className={`v2-container v2-reveal ${visible ? 'is-visible' : ''}`}>
        <h2 className="v2-section-title v2-section-title--center">
          For <em className="v2-em-green">Singles</em>
        </h2>

        <div className="v2-singles-grid">
          <div className="v2-singles-copy">
            <h3>
              Already <em className="v2-em-green">going out?</em>
            </h3>
            <p>You’ve picked the place. Your friends are on their way. Someone you’d like to meet could be there too.</p>
            <p>Open Ivy to see where people are checked in before you decide where to go.</p>
            <h3>
              Make room for <em className="v2-em-green">someone new.</em>
            </h3>
            <p>When you arrive, check in and see who’s open to meeting. Send a quick message, find each other, and see how it goes.</p>
          </div>

          <div className="v2-singles-testimonials">
            {TESTIMONIALS.map((testimonial, index) => (
              <TestimonialCard key={testimonial.name} testimonial={testimonial} style={visible ? { transitionDelay: `${index * 120}ms` } : undefined} />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ForSinglesSection
